export default __webpack_public_path__ + "static/media/kangoo2.83d969f7.jpg";